import React from 'react';
import { LoadingOverlay } from '@eb/eds-loading-overlay';

export default class LoadingPage extends React.PureComponent {
    render() {
        return <LoadingOverlay isShown={true} />;
    }
}
